import './close.scss';

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const CloseButton = forwardRef((props, ref) => {
  const className = classNames({
    close: true,
    [props.className]: props.className,
  });

  return (
    <button
      type="button"
      aria-label="Close"
      ref={ref}
      className={className}
      onClick={props.onClick}
    >
      {props.children}
    </button>
  );
});

CloseButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
};

export default CloseButton;
